@if (modal()) {
<div
  class="confirm-modal__overlay"
  (click)="onOverlayClick()"
  (keydown.enter)="onOverlayClick()"
  (keydown.space)="onOverlayClick()"
  tabindex="-1">
  <div
    class="confirm-modal__panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-busy]="modal()?.isLoading ? 'true' : null"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    (keydown.space)="$event.stopPropagation()"
    tabindex="0">
    <div class="confirm-modal__header" [class.confirm-modal__header--danger]="modal()?.variant === 'danger'">
      <div class="confirm-modal__header-main">
        <span class="confirm-modal__icon" [class.confirm-modal__icon--danger]="modal()?.variant === 'danger'">
          <ng-glyph [name]="getIcon()"></ng-glyph>
        </span>
        <h2 class="confirm-modal__title">{{ modal()?.title }}</h2>
      </div>
      <button
        class="confirm-modal__close"
        type="button"
        aria-label="Close dialog"
        (click)="onCancel()"
        [disabled]="!!modal()?.isLoading">
        ✕
      </button>
    </div>
    <p class="confirm-modal__message">{{ modal()?.message }}</p>

    <div class="confirm-modal__actions">
      <app-button type="button" variant="secondary" (click)="onCancel()" [disabled]="!!modal()?.isLoading">
        {{ modal()?.cancelText }}
      </app-button>
      <app-button
        type="button"
        [variant]="modal()?.variant === 'danger' ? 'danger' : 'primary'"
        (click)="onConfirm()"
        [disabled]="!!modal()?.isLoading">
        {{ modal()?.isLoading ? "Working..." : modal()?.confirmText }}
      </app-button>
    </div>
  </div>
</div>
}
